import type { User } from 'firebase/auth';
import type { UserType } from 'src/auth/types';

import { onAuthStateChanged as onAuthStateChangedFB } from 'firebase/auth';

import { ROLES } from '../consts';
import { AUTH } from '../firebase';
import { getAccount } from './getAccount';

export async function onAuthStateChanged(callback: (user: UserType) => void) {
  return onAuthStateChangedFB(AUTH, async (user: User | null) => {
    if (user) {
      const account = await getAccount(user.uid);

      if (!account) {
        callback(null);
        return;
      }

      if (Object.values(ROLES).includes(account.role)) {
        callback({ ...user, ...account });
      } else {
        callback(null);
      }
    } else {
      callback(null);
    }
  });
}
